import ResourceModel from "models/convention-api/ResourceModel"

export default class ConventionSessionCapacity extends ResourceModel {
  protected static basePath = "/v1/convention_providers/:provider_id/convention_session_capacities"

  seats_taken!: number
  total_capacity!: number
  total_in_a_room!: number | null
}
